import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

/** positive 공개·완료 / neutral 등록 중·대기 / attention 처리할 건 / warning 주의 / danger 숨김·취소·실패. */
export type StatusTone = 'positive' | 'neutral' | 'attention' | 'warning' | 'danger';

const TONE_CLASS: Record<StatusTone, { readonly badge: string; readonly dot: string }> = {
  positive: { badge: 'bg-emerald-50 text-emerald-700', dot: 'bg-emerald-500' },
  neutral: { badge: 'bg-foreground/[0.05] text-foreground/70', dot: 'bg-foreground/35' },
  attention: { badge: 'bg-brand-lime/40 text-foreground', dot: 'bg-foreground' },
  warning: { badge: 'bg-amber-50 text-amber-800', dot: 'bg-amber-500' },
  danger: { badge: 'bg-red-50 text-red-700', dot: 'bg-red-500' },
};

interface StatusBadgeProps {
  readonly tone: StatusTone;
  readonly children: ReactNode;
}

/** 상태 배지 — 점 + 글자 알약. 색은 꾸밈이고 의미는 글자가 전한다. */
export const StatusBadge = ({ tone, children }: StatusBadgeProps): ReactElement => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap',
      TONE_CLASS[tone].badge,
    )}
  >
    <span aria-hidden="true" className={cn('size-1.5 rounded-full', TONE_CLASS[tone].dot)} />
    {children}
  </span>
);
